import styled from 'styled-components';

import {
    designColor,
    floorGameDuration as duration,
    floorGameEasing as easing,
    styledInteraction,
    styledMedia,
    styledReset,
    styledTypography,
} from '@pkg/primitives';

import { tokens } from '../CurrencySelector.tokens';

export const StyledMenu = styled.div`
    border-radius: ${tokens.menu.radius}em;
    background-color: rgb(255, 255, 255, 0.2);
    backdrop-filter: blur(4px);
`;

export const List = styled.ul`
    ${styledReset.list};
    display: grid;
    gap: ${tokens.menu.list.gap}em;
    padding: ${tokens.menu.list.padding}em;
`;

export const StyledItem = styled.li``;

export const Option = styled.button.attrs({ type: 'button' })`
    ${styledReset.button};

    display: flex;
    align-items: center;
    gap: ${tokens.menu.option.gap}em;
    padding: ${tokens.menu.option.padding.y}em ${tokens.menu.option.padding.x}em;
    width: 100%;
    font-size: inherit;
    text-align: left;
    border-radius: ${tokens.menu.option.radius}em;
    background-color: transparent;
    outline: 2px solid transparent !important;
    outline-offset: 2px;
    transition-property: opacity, background-color, outline-color;
    transition-duration: ${duration.normal}ms;
    transition-timing-function: ${easing.cubic};

    &[aria-pressed] {
        background-color: rgb(255, 255, 255, 0.1);
    }

    &[disabled] {
        ${styledInteraction.interactionDisable};
        opacity: 0.8;
    }

    &:focus-visible {
        outline-color: ${designColor.brandPurple} !important;
    }

    &:hover {
        background-color: rgb(255, 255, 255, 0.06);
    }

    &:active {
        background-color: rgb(255, 255, 255, 0.04);
    }
`;

export const Symbol = styled.div`
    display: grid;
    place-items: center;
    place-content: center;
    width: ${tokens.menu.symbol.size}em;
    height: ${tokens.menu.symbol.size}em;
    border-radius: 999px;
    background-color: rgb(255, 255, 255, 1);
`;

export const IconWrapper = styled.div`
    ${styledMedia.iconWrapper};
    width: ${tokens.menu.symbol.iconSize}em;
    height: ${tokens.menu.symbol.iconSize}em;
    color: black;
`;

export const Name = styled.p`
    ${styledTypography.allianceBase};
    font-size: ${tokens.name.fontSize}em;
    font-weight: 700;
    letter-spacing: -0.02em;
    color: var(--currency-selector-color);
`;
